import { useEffect } from 'react';
import type { AgEventListener, AgPublicEventType, GridApi } from 'ag-grid-community';

// A component inside a grid (status panel, header) unmounts after its grid is destroyed, on a route change or a tab
// switch. A grid API call then logs AG Grid warning #26 and, in dev builds, draws the warning panel over the grid, so
// the cleanup removes the listener only from a live grid; a destroyed grid has dropped its listeners already.
export const useGridEventListener = <TData, TEventType extends AgPublicEventType>(
  api: GridApi<TData>,
  eventType: TEventType,
  listener: AgEventListener<TData, unknown, TEventType>,
) => {
  useEffect(() => {
    api.addEventListener(eventType, listener);
    return () => {
      if (!api.isDestroyed()) api.removeEventListener(eventType, listener);
    };
  }, [api, eventType, listener]);
};
